export type Attachment = {
  id: number
  fileName: string
  url: string
}

export function hasRfpAttachments(attachments: Attachment[]) {
  return attachments.length > 0
}
